<template>


    <b-button class="px-4 shadow header-btn ">
      <slot/>
    </b-button>


</template>

<script>
export default {
  name: "Bt7",
  props: ["href"],

}
</script>

<style scoped>

.header-btn:hover {
  background: var(--light-secondary) !important;
  color: white !important;
}

.header-btn {
  color: var(--dark) !important;
  background: var(--primary) !important;
  border: none !important;
}
</style>